import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isMobile = window.innerWidth < 768;

    // Scroll the window
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: isMobile ? "auto" : "smooth"
    });

    // Fallbacks (mobile + Safari)
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Handle scrollable containers (VERY important for mobile layouts)
    const scrollers = document.querySelectorAll(
      ".App, #root, main, .pageShell, .ctb-page"
    );

    scrollers.forEach((el) => {
      if (el) {
        el.scrollTo({
          top: 0,
          behavior: isMobile ? "auto" : "smooth"
        });
      }
    });

  }, [pathname]);

  return null;
}

export default ScrollToTop;